import { render, staticRenderFns } from "./cardDemand.vue?vue&type=template&id=5cd54d66&"
import script from "./cardDemand.vue?vue&type=script&lang=js&"
export * from "./cardDemand.vue?vue&type=script&lang=js&"
import style0 from "./cardDemand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports